import { Tabs } from "flowbite-react";
import Viewdetails from "../component/order/viewdetails";
import Cutting from "../component/order/cutting/Cutting";
// import Sewing from "../component/order/Sewing";
// import Finishing from "../component/order/Finishing";
import ReadytoSewing from "../component/order/ReadytoSewing/ReadytoSewing";
import Cutting_dc from "../component/order/Cutting_Dc/cutting_dc";
import { useSearchParams } from "react-router-dom";
import { useSidebar } from "../context/SidebarOpenContext";
import Breadcrumb from "../hooks/Breadcrumb";
import { RiInboxArchiveFill } from "react-icons/ri";
import Viewordercolordetails from "../component/order/view_order_color_details";
import React, { useState } from "react";
import Feeding from "../component/order/feeding/Feeding";
import Producation from "../component/order/producation/Producation";
import SewingDC from "../component/order/sewing_dc/Sewing_dc";
import Inward from "../component/order/inward/Inward";
import Boxing from "../component/order/boxing/Boxing";
import Pressing from "../component/order/pressing/Pressing";

function ViewSubOrderDetails() {

    const [searchParams] = useSearchParams();
    const Order_id = searchParams.get("id");
    const Sub_Order_id = searchParams.get("sid");
    const { isSidebarOpen } = useSidebar();

    const [activeTab, setActiveTab] = useState("Cutting");

    const breadcrumbItems = [
        {
            href: "/order",
            label: "Order",
            icon: (
                <RiInboxArchiveFill className="flex-shrink-0 w-5 h-5  " />

            ),
        },
        {
            href: `/view_order_details?id=${Order_id}`,
            label: "View Order",
            icon: (
                <RiInboxArchiveFill className="flex-shrink-0 w-5 h-5  " />
            ),
        },
        {
            label: "Color-Based Order View",
        },

    ];



    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >
            <div className="p-4 rounded-lg dark:border-gray-700 mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <div className="space-y-6">
                        <Breadcrumb items={breadcrumbItems} />
                        <Viewdetails orderid={Order_id} />
                        <Viewordercolordetails Sub_Order_id={Sub_Order_id} />

                       
                        <div className="w-full">
                            <div className="relative right-0">
                                <ul
                                    className="relative flex flex-wrap px-1.5 py-1.5 list-none rounded-md bg-slate-100"
                                    role="tablist"
                                >
                                    {["Cutting", "Sewing", "Finishing"].map((tab) => (
                                        <li key={tab} className="z-30 flex-auto text-center">
                                            <button
                                                className={`z-30 flex items-center justify-center w-full px-0 py-2 text-sm mb-0 transition-all ease-in-out border-0 rounded-md cursor-pointer ${activeTab === tab
                                                        ? "text-slate-700 font-bold bg-white"
                                                        : "text-slate-600"
                                                    }`}
                                                onClick={() => setActiveTab(tab)}
                                                role="tab"
                                                aria-selected={activeTab === tab}
                                                aria-controls={tab}
                                            >
                                                {tab.charAt(0).toUpperCase() + tab.slice(1)}
                                            </button>
                                        </li>
                                    ))}
                                </ul>

                                <div className="p-5">
                                    {activeTab === "Cutting" && (
                                        <Tabs
                                            aria-label="Full width tabs"
                                            className="w-full border-b border-gray-200 "
                                        >
                                            <Tabs.Item title="Cutting" active>
                                                <Cutting orderid={Order_id} Sub_Order_id={Sub_Order_id} />
                                            </Tabs.Item>
                                            <Tabs.Item title="Ready to Sew">
                                                <ReadytoSewing orderid={Order_id} Sub_Order_id={Sub_Order_id} />
                                            </Tabs.Item>
                                            <Tabs.Item title="Cutting Issue">
                                                <Cutting_dc orderid={Order_id} Sub_Order_id={Sub_Order_id} />
                                            </Tabs.Item>
                                        </Tabs>
                                        
                                    )}
                                    {activeTab === "Sewing" && (
                                        <Tabs
                                        aria-label="Full width tabs"
                                        className="w-full border-b border-gray-200 "
                                    >
                                        <Tabs.Item title="Feeding" active>
                                            <Feeding orderid={Order_id} Sub_Order_id={Sub_Order_id} />
                                        </Tabs.Item>
                                        <Tabs.Item title="Production">
                                            <Producation orderid={Order_id} Sub_Order_id={Sub_Order_id} />
                                        </Tabs.Item>
                                     
                                        {/* <Tabs.Item title="Sewing Issue">
                                            <SewingDC orderid={Order_id} Sub_Order_id={Sub_Order_id} />
                                        </Tabs.Item> */}
                                    </Tabs>
                                    )}
                                    {activeTab === "Finishing" && (
                                          <Tabs
                                          aria-label="Full width tabs"
                                          className="w-full border-b border-gray-200 "
                                      >
                                          <Tabs.Item title="Inwards" active>
                                              <Inward orderid={Order_id} Sub_Order_id={Sub_Order_id} />
                                          </Tabs.Item>
                                          <Tabs.Item title="Pressing" active>
                                              <Pressing orderid={Order_id} Sub_Order_id={Sub_Order_id} />
                                          </Tabs.Item>
                                          {/* <Tabs.Item title="Boxing">
                                              <Boxing orderid={Order_id} Sub_Order_id={Sub_Order_id} />
                                          </Tabs.Item> */}
                                          </Tabs>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewSubOrderDetails;
